// Проверка динамиков до входа в звонок: короткий тон синтезируется WebAudio и
// проигрывается через <audio>, а не через destination контекста, — только у
// элемента есть setSinkId, и только так тон уйдёт в выбранное устройство
// вывода, а не в системное.

const TONE_MS = 700

export async function playTestTone(outputDeviceId?: string): Promise<void> {
  if (typeof AudioContext === 'undefined') return
  const ctx = new AudioContext()
  const destination = ctx.createMediaStreamDestination()
  const element = new Audio()
  element.srcObject = destination.stream

  try {
    // Тип обещает setSinkId всегда, реальность — нет (Safari): проверяем.
    if (outputDeviceId && 'setSinkId' in element) await element.setSinkId(outputDeviceId)
    const now = ctx.currentTime
    // Две ноты (A5 → E6) с мягкими фронтами: щелчок на резком старте звучит
    // как поломка, а не как проверка.
    for (const [offset, freq] of [
      [0, 880],
      [0.25, 1318.5],
    ] as const) {
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()
      osc.type = 'sine'
      osc.frequency.value = freq
      gain.gain.setValueAtTime(0.0001, now + offset)
      gain.gain.exponentialRampToValueAtTime(0.15, now + offset + 0.03)
      gain.gain.exponentialRampToValueAtTime(0.0001, now + offset + 0.3)
      osc.connect(gain).connect(destination)
      osc.start(now + offset)
      osc.stop(now + offset + 0.35)
    }
    await element.play()
    await new Promise<void>((resolve) => setTimeout(resolve, TONE_MS))
  } finally {
    element.pause()
    element.srcObject = null
    await ctx.close().catch(() => {})
  }
}
